// ══════════════════════════════════════════════════════════════════
//  listaVidas — fachada da Lista de vidas (Hub como fonte de verdade)
//
//  Toda chamada vai para /api/lista-vidas, a rota do nosso servidor
//  (server/lista-vidas/), que lê e escreve as vidas no Hub (api-bluehub).
//  O navegador não tem chave do Hub.
// ══════════════════════════════════════════════════════════════════

import { listaVidasApi } from './core';

export const meuPapelListaVidas = listaVidasApi.meuPapel;
export const listarEmpresasListaVidas = listaVidasApi.listarEmpresas;
export const listarVidasListaVidas = listaVidasApi.listarVidas;
export const visaoGeralListaVidas = listaVidasApi.visaoGeral;
export const obterVidaListaVidas = listaVidasApi.obterVida;
export const listarSolicitacoesListaVidas = listaVidasApi.listarSolicitacoes;
export const obterSolicitacaoListaVidas = listaVidasApi.obterSolicitacao;
export const criarSolicitacaoListaVidas = listaVidasApi.criar;
export const aprovarSolicitacaoListaVidas = listaVidasApi.aprovar;
export const retomarSolicitacaoListaVidas = listaVidasApi.retomar;
export const rejeitarSolicitacaoListaVidas = listaVidasApi.rejeitar;
export const cancelarSolicitacaoListaVidas = listaVidasApi.cancelar;
export const salvarAdicionalVidaListaVidas = listaVidasApi.salvarAdicionalVida;
export const liberarZenklubListaVidas = listaVidasApi.liberarZenklub;
export const salvarBonificacaoListaVidas = listaVidasApi.salvarBonificacao;

export {
  CAMPOS_ALTERAVEIS, ADICIONAIS_PERMITIDOS, STATUS_ABERTOS, ListaVidasGatewayError,
  ADICIONAIS_VIDA, ADICIONAIS_EMPRESA, STATUS_POR_ADICIONAL, ADICIONAL_LABELS, STATUS_ADICIONAL_LABELS,
  mesesTocados, hojeIsoBrasilia,
} from '@modules/listaVidas';

export type {
  Papel, TipoOperacao, SolicitacaoStatus, CampoDados, AvisoCodigo, MotivoConflito,
  AcaoSolicitacao, ListaVidasPapelInfo, EmpresaHubDTO, ListaVidasEmpresas,
  VidaResumoDTO, VidaCompletaDTO, ListaVidasVidas, CamposAdicao, NovaSolicitacao,
  RespostaHubDTO, ErroRegistradoDTO, ConflitoDTO, SolicitacaoDTO, FiltroSolicitacoes,
  EventoSolicitacao, ResultadoAplicacao, RespostaAplicacao,
  AdicionalVida, AdicionalEmpresa, StatusAdicional, DivergenciaAdicional, BonificacaoEmpresa,
  ResumoAdicionais, ControleAdicionalDTO, ControleAdicionaisDTO, LiberacaoZenklubDTO,
  AdicionaisEmpresaDTO, SalvarAdicionalVidaInput, LiberarZenklubInput, SalvarBonificacaoInput,
  VisaoGeralEmpresaDTO, ListaVidasVisaoGeral,
} from '@modules/listaVidas';
